import { render } from "./Staff.vue?vue&type=template&id=629b0114&scoped=true&ts=true"
import script from "./Staff.vue?vue&type=script&lang=ts"
export * from "./Staff.vue?vue&type=script&lang=ts"

import "./Staff.vue?vue&type=style&index=0&id=629b0114&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629b0114"]])

export default __exports__